"use client";

import { useEffect, useState } from "react";

const IOS_VIDEO_POSTER = "/video_poster.jpeg";

const isIOSDevice = () => {
  if (typeof navigator === "undefined") {
    return false;
  }

  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const RealequityVideoComponent: React.FC<{
  autoPlay?: boolean;
  muted?: boolean;
  controls?: boolean;
  loop?: boolean;
  poster?: string;
  url: string;
  className?: string;
}> = ({ url, autoPlay, muted, controls, loop, poster, className }) => {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    setIsIOS(isIOSDevice());
  }, []);

  const shouldAutoPlay = autoPlay ?? true;
  const shouldMute = muted ?? true;
  const shouldControls = controls ?? false;

  return (
    <video
      autoPlay={shouldAutoPlay}
      loop={loop ?? true}
      muted={shouldMute}
      playsInline
      controls={shouldControls || !shouldMute}
      poster={
        !shouldAutoPlay && isIOS ? (poster ?? IOS_VIDEO_POSTER) : undefined
      }
      className={
        className
          ? className
          : `object-cover h-full w-full ${!shouldControls && shouldMute ? "-z-10" : ""}`
      }
    >
      <source src={url} type="video/mp4" />
    </video>
  );
};
